import { useQuery } from "@tanstack/react-query";
import { useAdminSession } from "@/hooks/useAdminSession";
import { listSubscriptions, type ListSubscriptionsParams } from "./subscriptions";

export function useAdminSubscriptions(params: ListSubscriptionsParams) {
  const enabled = useAdminSession();
  return useQuery({
    queryKey: ["admin", "subscriptions", params],
    enabled,
    queryFn: () => listSubscriptions(params),
  });
}